/**
 * Types for GET /api/v2/renter-hub/me/cert-status/ — the IVR facts + text
 * layer exposed for the new renter interface.
 */

export interface PendingSignatures {
  total_count: number;
  documents: string[];
  by_recipient: Record<string, { count: number; documents: string[] }>;
}

export interface MissingQuestions {
  total_count: number;
  question_labels: string[] | null;
  by_cert_member: Record<string, { count: number; question_ids: number[] }>;
}

export interface CertActionItems {
  profile_gaps_cert_member_ids?: number[];
  rejected_docs_cert_member_ids?: number[];
  insufficient_files_cert_member_ids?: number[];
  pending_signatures: PendingSignatures;
  missing_questions: MissingQuestions;
}

export interface CertStatusDetail {
  status_text: string;
  /**
   * Lifecycle phase from Thor (ENG-3451). Terminal and adverse phases mean a
   * decision has been issued, so no renter action is expected.
   */
  phase?: CertStatusPhase;
  action_items: CertActionItems;
}

export type CertStatusPhase =
  | 'initial'
  | 'in_progress'
  | 'waitlist'
  | 'adverse'
  | 'terminal_approved'
  | 'terminal_non_approved';

/** Phases where a decision has been issued — no renter action expected. */
export const DECISION_PHASES: CertStatusPhase[] = [
  'adverse',
  'terminal_approved',
  'terminal_non_approved',
];

/** Action item ids surfaced in the cert-status "What you still need to do" list. */
export type CertStatusActionId =
  | 'questions'
  | 'signatures'
  | 'profile_gaps'
  | 'rejected_docs'
  | 'insufficient_files';

/** cert_id (number) → status detail. */
export type CertStatusMap = Record<number, CertStatusDetail>;
